import React, { Fragment, useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import SVG from './SVG.jsx';

export default function CollectionSidebar(props) {
  if (props.contents.links.length === 0) {
    return (null);
  }
  const highlights = props.contents.highlights || [];
  const activeIndex = props.contents.links.findIndex(link => link.links.some(link => link.url === `/collections/${props.collectionHandle}`)) || 0;
  const [active, setActive] = useState(activeIndex)
  return <aside className="product-list-sidebar">
    {props.breadcrumbs && <div className="breadcrumb-navigation">
      {props.breadcrumbs.map((breadcrumb, i) => {
        return <Fragment key={i}>
          <span>
            <a href={`/collections/${breadcrumb.handle}`} title={breadcrumb.label}>{breadcrumb.label}</a>
          </span>
          {i < props.breadcrumbs.length - 1 && <span className="sep"><SVG icon="arrow-thin-right" /></span>}
        </Fragment>
      })}
      </div>}
    <div className="sidebar-menu--desktop">
      <ul className="collection-sidebar-menu">
        {props.contents.links.map((link, i) => {
          let cName = 'sidebar-menu--dropdown';
          if (active === i) {
            cName += ' active expanded';
          }
          if (link.links.length === 0) {
            return <li className={cName} key={i}>
              <a href={link.url}>
                {link.title}
              </a>
            </li>
          }
          return <li className={cName} key={i}>
            <a href={link.url}>
              {link.title}
              <span className="icon" onClick={e => {
                e.preventDefault();
                if (active === i) {
                  setActive(null);
                } else {
                  setActive(i);
                }
              }}>
                <span className="plus">
                  <SVG icon="plus" />
                </span>
                <span className="minus">
                  <SVG icon="minus" />
                </span>
              </span>
            </a>
            <CSSTransition
              in={active === i}
              mountOnEnter={true}
              unmountOnExit={true}
              addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
              classNames="active">
              <ul>
                {link.links.map((link, j) => {
                  let liCName = '';
                  if (highlights.some(highlight => `/collections/${highlight}` === link.url)) {
                    liCName = 'underline';
                  }
                  let cName = '';
                  if (link.url === `/collections/${props.collectionHandle}`) {
                    cName = 'active';
                  }
                  return <li key={j} className={liCName}><a href={link.url} className={cName}>{link.title}</a></li>
                })}
              </ul>
            </CSSTransition>
          </li>
        })}
      </ul>
    </div>
  </aside>
}